export default "__VITE_ASSET__BnJO1aMc__";